"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreContextConsumer = exports.CoreContextProvider = void 0;
const React = require("react");
const context = React.createContext({});
exports.CoreContextProvider = context.Provider;
exports.CoreContextConsumer = context.Consumer;
